document.addEventListener('DOMContentLoaded', function() {
  const giftVariantId = 44486174507200;

  function checkAndAddGift() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const giftItem = cart.items.find(item => item.variant_id === giftVariantId);
        const qualifies = cart.total_price >= 10000;

        if (qualifies && !giftItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftVariantId, quantity: 1 })
          }).then(updateFlyoutCart);
        } else if (!qualifies && giftItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 })
          }).then(updateFlyoutCart);
        } else {
          return updateFlyoutCart();
        }
      })
      .catch(err => {
        console.error("Gift logic error:", err);
      });
  }

  function updateFlyoutCart() {
    // ... same as previous, updates the offcanvas DOM ...
  }

  // Patch fetch to listen for cart update requests
  const originalFetch = window.fetch;
  window.fetch = function() {
    // Listen for cart changes/updates
    if (
      typeof arguments[0] === 'string' &&
      (
        arguments[0].includes('/cart/change.js') ||
        arguments[0].includes('/cart/update.js') ||
        arguments[0].includes('/cart/add.js') ||
        arguments[0].includes('/cart/clear.js')
      )
    ) {
      return originalFetch.apply(this, arguments).then(function(response) {
        // After the cart update finishes, run gift logic
        setTimeout(checkAndAddGift, 200);
        return response;
      });
    }
    return originalFetch.apply(this, arguments);
  };

  // Also run on offcanvas open
  var cartOffcanvas = document.getElementById('cart-details');
  if (cartOffcanvas) {
    cartOffcanvas.addEventListener('show.bs.offcanvas', function () {
      checkAndAddGift();
    });
  }

  // Fallback: still listen for direct DOM interaction, but do not rely on this alone
  document.body.addEventListener('click', function(event) {
    if (
      event.target.classList.contains('qty-update') ||
      event.target.classList.contains('remove-product')
    ) {
      setTimeout(checkAndAddGift, 1000);
    }
  });

  document.body.addEventListener('change', function(event) {
    if (event.target.classList.contains('quantity-input')) {
      setTimeout(checkAndAddGift, 1000);
    }
  });

  // Initial render
  checkAndAddGift();
});